var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.233,
    height: 31.292,
    viewBox: "0 0 33.233 31.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fuel",
    d: "M192.625,185.687v7.74H178.952v-7.74Zm0,8.911v7.74H178.952V194.6Zm-1.778,1.779H180.732v4.183h10.115Zm4.9-13.787v15.271c2.081,0,3.509.933,3.509,3.125v4.471a.629.629,0,1,0,1.241-.2v-7.786h-.647a.889.889,0,0,1-.89-.89V190.72a.889.889,0,0,1,.89-.89h.647v-2.315l-2.177-2.121a.887.887,0,0,1,1.237-1.272l2.718,2.649v3.059h.648a.889.889,0,0,1,.89.89v5.857a.889.889,0,0,1-.89.89h-.648v7.787a2.4,2.4,0,1,1-4.8.2v-4.471c0-1.173-.655-1.346-1.73-1.346v9.3H198.5V212.1h2.6v1.779H170.584V212.1h2.6v-3.157h2.745V182.589h19.82Zm6.287,9.02h-1.3v4.079h1.3Zm-27.074,19.115V212.1h21.754v-1.378Zm19.008-26.356H177.71v24.577h16.262Zm-3.126,3.1H180.732v4.182h10.115Z",
    transform: "translate(-170.584 -182.589)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.bd82aacc7e82719ffd8514c1e128579f.svg";
export { ForwardRef as ReactComponent };